import {Injectable} from "@angular/core";

@Injectable()
export class RoleConstants {

  public SITE_ACCESS:string = "site_access";
  public VIEW_USER_ACCOUNTS:string = "view_user_account";
  public MODIFY_USER_ACCOUNT:string = "modify_user_account";
}